import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
export var BreadcrumbItemContext = React.createContext(undefined);
export var BreadcrumbItemContextProvider = function (props) {
    var path = props.path, children = props.children;
    return (_jsx(BreadcrumbItemContext.Provider, { value: path, children: children }));
};
export var useBreadcrumbItemPath = function (props) {
    var _a;
    var contextPath = React.useContext(BreadcrumbItemContext);
    return (_a = props.path) !== null && _a !== void 0 ? _a : contextPath;
};
